export default __webpack_public_path__ + "static/media/checkShield.7fc220a7.svg";